import { isEmpty } from "lodash";
import { Redirect, Route, Switch } from "react-router-dom";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { CurrentLessonContextProvider } from "@circle-react/contexts/currentLessonContext";
import { canManageSpace } from "@circle-react/helpers/spaceHelpers";
import { spaces } from "@circle-react/helpers/urlHelpers";
import { EditLesson } from "./Lessons/Edit";
import { ShowLesson } from "./Show/Lesson";
import { Summary } from "./Summary";

export const CourseSpaceRoutes = () => {
  const { data: space } = useCurrentSpaceContext();
  if (!space || isEmpty(space)) return null;

  return (
    <Switch>
      <Route
        path="/c/:spaceSlug/sections/:sectionId/lessons/:lessonId"
        component={ShowLesson}
      />
      <Route path="/c/:spaceSlug/edit-lesson/sections/:sectionId/lessons/:lessonId">
        {canManageSpace(space) ? (
          <CurrentLessonContextProvider>
            <EditLesson />
          </CurrentLessonContextProvider>
        ) : (
          <Redirect to={spaces.show({ spaceSlug: space?.slug })} />
        )}
      </Route>
      <Route path="/c/:spaceSlug" component={Summary} />
    </Switch>
  );
};
